import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';

/*
 * Phase guard for the save-protocol cascade. Drives the short-circuit logic
 * documented in save-protocol-cascade-design.md §1.8: when a higher-level
 * phase is in progress, lower-level entry points become defensive no-ops.
 *
 * `idle` is the resting value. Each `running-*` value corresponds to a
 * top-level entry method on SaveProtocolCascadeEffects.
 */
export type SaveProtocolCascadePhase =
  | 'idle'
  | 'running-pipeline'
  | 'running-resource'
  | 'running-method-type'
  | 'running-case-type';

interface SaveProtocolCascadeStateModel {
  phase: SaveProtocolCascadePhase;
}

const INITIAL_STATE: SaveProtocolCascadeStateModel = {
  phase: 'idle',
};

@Injectable()
export class SaveProtocolCascadeState extends ComponentStore<SaveProtocolCascadeStateModel> {
  constructor() {
    super({ ...INITIAL_STATE });
  }

  // ============================================================================
  // Selectors
  // ============================================================================

  public readonly phase$ = this.select((state) => state.phase);

  // ============================================================================
  // Updaters
  // ============================================================================

  public readonly setPhase = this.updater((state, phase: SaveProtocolCascadePhase) => ({
    ...state,
    phase,
  }));
}
